export default __webpack_public_path__ + "static/media/WhatisGSDInsight_Image.3fefaca7.png";